import { BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ConditionElseExitLine = styled("div")<BoxProps>(({ theme }) => ({
  position: "absolute",
  borderLeft: "var(--tree-lines-width, 2px) solid var(--if-else-lines-color)",
  borderTop: "var(--tree-lines-width, 2px) solid var(--if-else-lines-color)",
  width: `var(--if-else-line-offset) `, //"20px",
  left: "calc(var(--if-else-line-offset) * -1)", //theme.spacing(-1.5),
  top: `calc(50% + ${theme.spacing(1)})`,
  bottom: 0,
}));
